import { getLinkStylesOn } from 'pcln-design-system'

function getAccessibleLinkStyles(props) {
  const { backgroundColor, textColor, isBold = false } = props

  const lightColor = textColor?.includes('light') ? textColor : 'text.lightest'
  const darkColor = !textColor?.includes('light') ? textColor : 'text.dark'

  return getLinkStylesOn(backgroundColor, lightColor, darkColor, isBold)(props)
}

export default getAccessibleLinkStyles
